import React from "react";
import { Link } from "react-router-dom";

const antStyle = {
    fontFamily: 'FiraSans-Regular',
    fontSize: '18px',
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    color: '#00a5ff'
}

const MarcaBreadcrumb = (props) => {
    let pantallaActual = props.pantallaActual;
    let menu = props.menu;
    let menuNode = [];

    if (menu) {
        /*
        propiedades de props.menu:
            * activo: elemento en el cual el usuario esta parado
            * normal: elementos restantes, sin ruteo ni elemento actual
        */
        menuNode = menu.map((m, index) => {
            if (m.activo == true) {
                return <li onClick={()=>m.funcion ? m.funcion():null}><b>{m.descripcion}</b></li>
            } else if (m.activo == false && m.anterior == true) {
                return <li onClick={()=>m.funcion ? m.funcion():null} style={antStyle}>{m.descripcion}</li>
            } else if (m.activo == false && m.normal == true) {
                return <li onClick={()=>m.funcion ? m.funcion():null} >{m.descripcion}</li>
            } else {
                return <li onClick={()=>m.funcion ? m.funcion():null} ><Link to={m.ruta} className="btn btn-link no-margin no-padding">{m.descripcion}</Link></li>
            }
        });
        
        return (<div>

            <ol className="breadcrumbNew">
                {menuNode}
            </ol>
        </div>);
    } else {
        return null;
    }
}

export default MarcaBreadcrumb